module.exports = __webpack_public_path__ + "img/ic_nav_star.99a573a1.svg";